// extracted by mini-css-extract-plugin
export var actionButton = "_e9-0";
export var attachmentLine = "_e9-1";
export var fileInput = "_e9-2";
export var fileUploadWrapper = "_e9-4";
export var footer = "_e9-3";
export var modalContent = "_e9-5";
export var paperclip = "_e9-6";
export var quillEditor = "_e9-7";